import { render, staticRenderFns } from "./FormulaExplain.vue?vue&type=template&id=0c4afdc7&scoped=true"
import script from "./FormulaExplain.vue?vue&type=script&lang=js"
export * from "./FormulaExplain.vue?vue&type=script&lang=js"
import style0 from "./FormulaExplain.vue?vue&type=style&index=0&id=0c4afdc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4afdc7",
  null
  
)

export default component.exports